import { createContext, useReducer } from "react";

import { CHANGE_THEME } from "../types";
import { uiReducer, initialState } from "../Reducers/uiReducer";

export const uiContext = createContext();

export const UiProvider = ({ children }) => {
  const [state, dispatch] = useReducer(uiReducer, initialState);

  const handleChangeTheme = () => {
    const appElement = document.querySelector(".app");
    if (state.darkmode) {
      appElement.classList.add("dark-theme");
    } else {
      appElement.classList.remove("dark-theme");
    }

    dispatch({
      type: CHANGE_THEME,
    });
  };

  return (
    <uiContext.Provider
      value={{
        darkmode: state.darkmode,
        handleChangeTheme,
      }}
    >
      {children}
    </uiContext.Provider>
  );
};
